import { useSelector, useDispatch } from "react-redux";

import lending_img_1 from '../../static/img/lending-img-1.png';
import lending_img_2 from '../../static/img/lending-img-2.png';
import lending_img_3 from '../../static/img/lending-img-3.png';
import lending_img_4 from '../../static/img/lending-img-4.png';
import lending_img_5 from '../../static/img/lending-img-5.png';
import lending_img_6 from '../../static/img/lending-img-6.png';
import lending_img_7 from '../../static/img/lending-img-7.png';
import lending_img_8 from '../../static/img/lending-img-8.png';
import lending_img_9 from '../../static/img/lending-img-9.png';
import lending_img_10 from '../../static/img/lending-img-10.png';
import lending_img_11 from '../../static/img/lending-img-11.png';

import { Header } from '../header/header';
import { Footer } from '../footer/footer';
import { StepOne } from './stepOne';
import { StepTwo } from './stepTwo';
import { StepThree } from './stepThree';
import { getCurrentStep, nextStep } from './formSlice';
import { useEffect, useState } from "react";
import { getTokens } from "../precalc/precalcApi";
import { setCookie, setToken, setTokenVsk } from "../precalc/precalcSlice";
import { FormManager } from "../home/formManager";
import { selectShowPopUpManager } from "../home/homeSlice";

export function Lending(props) {
    const {type} = props
    const step = useSelector(getCurrentStep);
    const dispatch = useDispatch();

    const showPopUpManager = useSelector(selectShowPopUpManager)

    const [idBank, setIdBank] = useState('1');
    const [mortgageBalance, setMortgageBalance] = useState(100000);

    useEffect(() => {
        console.log('type', type)
        getTokens(function (data) {
            console.log('data.res', data)
            dispatch(setToken(data.res.token))
            dispatch(setCookie(data.res.cookie))
            dispatch(setTokenVsk(data.res.token_vsk))
        })
    }, []);

    return (
        <>
            <Header />

            <section className="one-ekran one-ekran-lending one-ekran-lending-2">
                <div className="conteiner">
                    <div className="one-ekran-contant one-ekran-contant-lending">
                        <h1 className="h1 h1-lending-1">Поможем экономить на страховании ипотеки до 50%!</h1>
                        <h1 className="h1 h1-lending-2">Не стоит тянуть до последнего!</h1>
                        <p className="one-ekran-contant-text one-ekran-contant-text-01">Узнайте, в какой компании выгодней
                            страховать ипотеку. </p>
                        <p className="one-ekran-contant-text one-ekran-contant-text-02">Мы заранее подберем вам лучшее предложение
                            на страхование ипотеки. Ваша страховка будет продлена вовремя!</p>
                        {step === 0 &&
                            <button onClick={() => { dispatch(nextStep()) }} className="button button-lending">Показать цены</button>
                        }

                    </div>
                </div>
            </section>

            { step === 1 && 
                <StepOne 
                    idBank={idBank} 
                    setIdBank={setIdBank}
                />
            }
            { step === 2 && <StepTwo idBank={idBank}/> }
            { step === 3 && <StepThree /> }

            <section className="two-ekran-lending">
                <div className="conteiner">
                    <div className="two-ekran-lending-contant">
                        <div className="two-ekran-lending-contant-item two-ekran-lending-contant-item-1">
                            <img src={lending_img_1} alt="lending" />
                        </div>
                        <div className="two-ekran-lending-contant-item two-ekran-lending-contant-item-2">
                            <img src={lending_img_2} alt="lending" />
                        </div>
                        <div className="two-ekran-lending-contant-item two-ekran-lending-contant-item-3">
                            <img src={lending_img_3} alt="lending" />
                        </div>
                        <div className="two-ekran-lending-contant-item two-ekran-lending-contant-item-4">
                            <img src={lending_img_4} alt="lending" />
                        </div>
                        <div className="two-ekran-lending-contant-item two-ekran-lending-contant-item-5">
                            <img src={lending_img_5} alt="lending" />
                        </div>
                        <div className="two-ekran-lending-contant-item two-ekran-lending-contant-item-6">
                            <img src={lending_img_6} alt="lending" />
                        </div>
                        <div className="two-ekran-lending-contant-item two-ekran-lending-contant-item-7">
                            <img src={lending_img_7} alt="lending" />
                        </div>
                        <div className="two-ekran-lending-contant-item two-ekran-lending-contant-item-8">
                            <img src={lending_img_8} alt="lending" />
                        </div>
                        <div className="two-ekran-lending-contant-item two-ekran-lending-contant-item-9">
                            <img src={lending_img_9} alt="lending" />
                        </div>
                        <div className="two-ekran-lending-contant-item two-ekran-lending-contant-item-10">
                            <img src={lending_img_10} alt="lending" />
                        </div>
                        <div className="two-ekran-lending-contant-item two-ekran-lending-contant-item-11">
                            <img src={lending_img_11} alt="lending" />
                        </div>
                    </div>
                </div>
            </section>
            
            {showPopUpManager &&
                <FormManager />
            }
            <Footer />
        </>
    )
}